module.exports = {
    "dismiss": `Odbaci`
};


//# sourceMappingURL=sr-SP.main.js.map
